import Typography from '@mui/material/Typography';
import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import ControlledAccordion from './ControlledAccordion';
import SummaryActions from './SummaryActions';
import { useSummaryType } from '../contexts/SummaryTypeContext';

export default function DefaultSummary({
    data,
    summary,
    simpleSummary,
    generating,
    generatingSimple,
    handleExpansion,
    expanded,
    party,
    election,
    setElection
}) {
    const { summaryType } = useSummaryType();

    const displayedSummary = summaryType === 'detailed' ? summary : simpleSummary;
    const isGenerating = summaryType === 'detailed' ? generating : generatingSimple;

    return (
        <>
            {displayedSummary && (
                <Typography color="text.primary" variant="p" gutterBottom>
                    {displayedSummary}
                    {isGenerating && (
                        <CircularProgress
                            color="secondary"
                            fontSize="6px"
                            size="12px"
                            sx={{ marginLeft: '10px' }}
                        />
                    )}
                </Typography>
            )}
            {!displayedSummary && isGenerating && (
                <CircularProgress color="secondary" size="24px" />
            )}
            <SummaryActions
                data={data}
                sx={{
                    mt: 1,
                    mb: 1
                }}
                party={party}
                election={election || data?.election}
                setElection={setElection}
            />
            <ControlledAccordion
                sx={{
                    mt: 1,
                    mb: 1
                }}
                paragraphs={data?.paragraphs}
                expanded={expanded}
                handleExpansion={handleExpansion}
            />
        </>
    );
}
